
import React, { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import ErrorMessage from 'components/common/ErrorMessage';
import toast from 'react-hot-toast';
import { Spinner } from 'reactstrap';
import Api from "services/api"
import { CustomSwitch } from 'components/common/Switch';
import { AsyncPaginate } from 'react-select-async-paginate';
import { selectCustomStyles } from 'components/common/Select';
import { setError, fetchDepartments, addDepartment, updateDepartment, departmentsSelector } from 'slices/departmentsSlice';
import { fetchFacilities } from 'slices/facilitiesSlice';

const AddDepartmentForm = ({ item, handleClose, callback, show, statusPerm }) => {
    const dispatch = useDispatch()
    const { register, handleSubmit, watch, formState: { errors }, control, setValue, } = useForm();
    const { error, loader } = useSelector(departmentsSelector);
    const [buttonLoader, setButtonLoader] = useState(false);

    useEffect(() => {
        setValue('department_name', item?.department_name || item?.name || '')
        setValue('address', item?.address || '');
        setValue('street_address', item?.street_address || '');
        setValue('city', item?.city || '');
        setValue('state', item?.state || '');
        setValue('zipcode', item?.zipcode || '');
        setValue('phone', item?.phone || '');
        setValue('cost_center', item?.cost_center || '');
        setValue('status', (typeof (item?.status) == "number") ? item?.status : 1)
        dispatch(setError({}))
    }, [item])

    const ResetField = () => {
        setValue('status', 1)
    }

    useEffect(() => {
        !show && ResetField();
        return () => ResetField()
    }, [show])


    const submitCallback = (status, message) => {
        if (status) {
            callback()
            toast.success(message, {
                className: "successToast",
            })
            handleClose()
            ResetField()
            setButtonLoader(false)
            dispatch(fetchDepartments(1))
        }
        else {
            toast.error(message, {
                className: "errorToast",
            });
            setButtonLoader(false)
        }
    };

    const onSubmit = (data) => {
        setButtonLoader(true);
        const payload = {
            department_name: data.department_name,
            address: data.address,
            street_address: data.street_address,
            city: data.city,
            state: data.state,
            zipcode: data.zipcode,
            phone: data.phone,
            cost_center: data.cost_center,
            status: data.status
        }
        if (item?.id) {
            dispatch(updateDepartment(payload, item?.id, submitCallback, false));
        }
        else
            dispatch(addDepartment(payload, submitCallback, false));
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)}>

            <div className="row-primary">
                <h2>Department Name *</h2>
                <div className="w-100">
                    <Controller
                        name="department_name"
                        control={control}
                        rules={{
                            required: "Department name is required"
                        }}
                        render={({ field }) =>
                            <div className="w-100">
                                <input className="input-in type_inp" type="text" name='department_name' placeholder='Department name' {...field} />
                                {errors?.department_name?.message &&
                                    <div style={{ marginBottom: 10 }}>
                                        <ErrorMessage text={errors?.department_name?.message} />
                                    </div>
                                }
                            </div>
                        }
                    />
                </div>
            </div>

            <div className="row-primary">
                <h2>Address *</h2>
                <div className="w-100">
                    <Controller
                        name="address"
                        control={control}
                        rules={{ required: "Address is required" }}
                        render={({ field }) =>
                            <div className="w-100">
                                <input className="input-in type_inp" type="text" name='address' placeholder='Address' {...field} />
                                {errors?.address?.message &&
                                    <div style={{ marginBottom: 10 }}>
                                        <ErrorMessage text={errors?.address?.message} />
                                    </div>
                                }
                            </div>
                        }
                    />
                </div>
            </div>

            <div className="row-primary">
                <h2>Street Address *</h2>
                <div className="w-100">
                    <Controller
                        name="street_address"
                        control={control}
                        rules={{ required: "Street Address is required" }}
                        render={({ field }) =>
                            <div className="w-100">
                                <input className="input-in type_inp" type="text" name='street_address' placeholder='Street Address' {...field} />
                                {errors?.street_address?.message &&
                                    <div style={{ marginBottom: 10 }}>
                                        <ErrorMessage text={errors?.street_address?.message} />
                                    </div>
                                }
                            </div>
                        }
                    />
                </div>
            </div>

            <div className="row-primary">
                <h2>City *</h2>
                <div className="w-100">
                    <Controller
                        name="city"
                        control={control}
                        rules={{ required: "City is required" }}
                        render={({ field }) =>
                            <div className="w-100">
                                <input className="input-in type_inp" type="text" name='city' placeholder='City' {...field} />
                                {errors?.city?.message &&
                                    <div style={{ marginBottom: 10 }}>
                                        <ErrorMessage text={errors?.city?.message} />
                                    </div>
                                }
                            </div>
                        }
                    />
                </div>
            </div>

            <div className="row-primary">
                <h2>State *</h2>
                <div className="w-100">
                    <Controller
                        name="state"
                        control={control}
                        rules={{ required: "State is required" }}
                        render={({ field }) =>
                            <div className="w-100">
                                <input className="input-in type_inp" type="text" name='state' placeholder='State' {...field} />
                                {errors?.state?.message &&
                                    <div style={{ marginBottom: 10 }}>
                                        <ErrorMessage text={errors?.state?.message} />
                                    </div>
                                }
                            </div>
                        }
                    />
                </div>
            </div>

            <div className="row-primary">
                <h2>Zipcode *</h2>
                <div className="w-100">
                    <Controller
                        name="zipcode"
                        control={control}
                        rules={{ required: "Zipcode is required" }}
                        render={({ field }) =>
                            <div className="w-100">
                                <input className="input-in type_inp" type="text" name='zipcode' placeholder='Zipcode' {...field} />
                                {errors?.zipcode?.message &&
                                    <div style={{ marginBottom: 10 }}>
                                        <ErrorMessage text={errors?.zipcode?.message} />
                                    </div>
                                }
                            </div>
                        }
                    />
                </div>
            </div>

            <div className="row-primary">
                <h2>Phone *</h2>
                <div className="w-100">
                    <Controller
                        name="phone"
                        control={control}
                        rules={{ required: "Phone is required" }}
                        render={({ field }) =>
                            <div className="w-100">
                                <input className="input-in type_inp" type="text" name='phone' placeholder='Phone' {...field} />
                                {errors?.phone?.message &&
                                    <div style={{ marginBottom: 10 }}>
                                        <ErrorMessage text={errors?.phone?.message} />
                                    </div>
                                }
                            </div>
                        }
                    />
                </div>
            </div>

            <div className="row-primary">
                <h2>Cost Center *</h2>
                <div className="w-100">
                    <Controller
                        name="cost_center"
                        control={control}
                        rules={{ required: "Cost Center is required" }}
                        render={({ field }) =>
                            <div className="w-100">
                                <input className="input-in type_inp" type="text" name='cost_center' placeholder='Cost Center' {...field} />
                                {errors?.cost_center?.message &&
                                    <div style={{ marginBottom: 10 }}>
                                        <ErrorMessage text={errors?.cost_center?.message} />
                                    </div>
                                }
                            </div>
                        }
                    />
                </div>
            </div>


            {statusPerm &&
                <div className="row-primary" style={{ alignItems: "center" }}>
                    <h2>Status</h2>
                    <Controller name="status" control={control} required
                        rules={{
                            required: true
                        }}
                        render={({ field }) => (
                            <CustomSwitch labelText={field.value == 1 ? "Active" : "Inactive"} checked={field.value} handleChange={(checked) => field.onChange(checked ? 1 : 0)} />
                        )}
                    />
                </div>
            }

            <div className="Form-footer">
                <button type="button" className="Cancle_button" data-bs-dismiss="modal">Cancel</button>
                <button type="submit" disabled={buttonLoader ? 'disabled' : ''} className="main_button">
                    {buttonLoader ?
                        <>
                            <Spinner size="sm">
                                Loading...
                            </Spinner>
                            <span> Loading</span>
                        </>
                        :
                        <span>
                            {item?.id ? "Update" : "Create"}
                        </span>
                    }
                </button>
            </div>
        </form>
    )
}

const AddDepartment = ({ item, onClose, callback, show, statusPerm }) => {
    return (
        <div className={`modal fade`} id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" role="dialog">
            <div className="modal-dialog modal-dialog-centered modal-lg">
                <div className="modal-content full_modal">
                    <div className="modal-header header_modal align-items-center">
                        <div></div>
                        <h5 className="modal-title_u">{item?.id ? "Update" : "Add"} Department</h5>
                        <button onClick={onClose} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body modal_form_body">
                        <AddDepartmentForm item={item} handleClose={onClose} show={show} callback={callback} statusPerm={statusPerm} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AddDepartment
